import constants from '../../constants/app-constants';

const initialState = {
  requests: null
};

const RewardDiscountCode = (state = initialState , action) => {
  switch(action.type){
  case constants.admin.REWARD_DISCOUNT_CODE_NEW : return {...state , requests : action.payload};

  case constants.admin.REWARD_DISCOUNT_CODE_GET: {
    return {...state, rewardDiscountCode: action.payload};
  }

  case constants.admin.REWARD_DISCOUNT_CODE_EDIT: {
    return {...state, rewardDiscountCodeEdit: action.payload};
  }

  default: return state;
  }
};

export default RewardDiscountCode;